import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field, Query } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { type BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { HTML } from '@adornis/cms/db/scalars.js';
import { DateTime } from 'luxon';

// TODO: move all remaining functionality into new Setting Class
@Entity()
export class GlobalSetting extends MongoEntity {
  static override _class = 'GlobalSetting';
  static override _collectionName = 'global-setting';

  @Field(type => HTML, { default: v => v ?? '' }) termsOfUse!: string;
  @Field(type => HTML, { default: v => v ?? '' }) imprint!: string;
  @Field(type => HTML, { default: v => v ?? '' }) dataPrivacy!: string;
  @Field(type => HTML, { default: v => v ?? '' }) accessibility!: string;
  @Field(type => HTML, { default: v => v ?? '' }) maintenanceModeRender!: string;

  @Field(type => DateTime) lastSendNewsletter: Maybe<DateTime>;
  @Field(type => DateTime) lastSendNewWorkshopDocumentsMails: Maybe<DateTime>;

  @Field(type => ID)
  logoID?: string;

  @Field(type => ID)
  emailBannerImageID: Maybe<string>;

  @Field(type => ID)
  multiCertTemplateID?: string;

  @Query(type => GlobalSetting)
  static getGlobalSetting() {
    return async (gqlFields: BaseQLSelectionSet<GlobalSetting>) => {
      const existingGlobalSetting = await (await getRawCollection(this._collectionName)).findOne({});
      if (existingGlobalSetting) return existingGlobalSetting as unknown as GlobalSetting;

      const newGlobalSetting = new this({});
      await newGlobalSetting.create();
      return newGlobalSetting;
    };
  }
}
